/**
 * IRI API
 *
 * Endpoints for UPC/brand validation against IRI cache.
 */

import { apiClient } from './client';
import type { IriValidateResponse } from './generated/contract-types';

export type { IriValidateResponse };

export const validateIri = async (upc: string, brand: string): Promise<IriValidateResponse> => {
  const trimmedUpc = upc.trim();
  const trimmedBrand = brand.trim();
  const response = await apiClient.get<IriValidateResponse>('/iri/validate', {
    params: { upc: trimmedUpc, brand: trimmedBrand },
  });

  return response.data;
};
